module.exports = __webpack_public_path__ + "img/ic_notes.c2feb56b.svg";